<template>
  <Modal title="Resposta Agravo" :active.sync="popupActivo">
    <form role="form" @submit.stop.prevent="onSubmit">
      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Ativo</span>
          <vs-switch
            color="success"
            v-model="formAgravoResposta.status"
            style="width: 60px"
          >
            <span slot="on">Ativo</span>
            <span slot="off">Inativo</span>
          </vs-switch>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Resposta</span>
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-help-circle"
            v-model="formAgravoResposta.resposta"
            id="resposta"
            name="resposta"
            v-validate="'required'"
            :state="validateState(veeFields, veeErrors, 'resposta')"
            :class="validateStateClass(veeFields, veeErrors, 'resposta')"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Negar Proposta</span>
          <vs-switch
            color="success"
            v-model="formAgravoResposta.negarProposta"
            style="width: 60px"
          >
            <span slot="on">Sim</span>
            <span slot="off">Não</span>
          </vs-switch>
        </div>
      </div>

      <div v-if="mostrarTabelaCoberturas" class="vx-row mb-6">
        <div class="vx-col w-full">
          <table class="styled-table">
            <thead>
              <tr>
                <th scope="col">Cobertura</th>
                <th scope="col">Ofertar cobertura?</th>
                <th scope="col">Aplicar agravo?</th>
                <th scope="col">Agravo do prêmio (%)</th>
                <th scope="col">Limite cobertura máxima (%)</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(cobertura, index) of listCoberturas" :key="index">
                <td class="w-48">{{ cobertura.name }}</td>
                <td>
                  <vs-checkbox
                    color="success"
                    v-model="
                      formAgravoResposta.coberturas[index].offer_coverage
                    "
                  ></vs-checkbox>
                </td>
                <td>
                  <vs-checkbox
                    color="success"
                    v-model="
                      formAgravoResposta.coberturas[index].increase_apply
                    "
                    :disabled="handleDisableOfertarCobertura(index)"
                  ></vs-checkbox>
                </td>
                <td>
                  <vs-input
                    class="w-full"
                    v-model="
                      formAgravoResposta.coberturas[index].increase_percentage
                    "
                    type="number"
                    step="0.01"
                    color="success"
                    icon-pack="feather"
                    icon="icon-percent"
                    :disabled="handleDisableAplicarAgravo(index)"
                    v-validate="{ required: true, min_value: 0, max_value: 100 }"
                    :id="`Porcentagem de incremento de ${cobertura.name}`"
                    :name="`Porcentagem de incremento de ${cobertura.name}`"
                    :state="
                      validateState(
                        veeFields,
                        veeErrors,
                        `Porcentagem de incremento de ${cobertura.name}`,
                      )
                    "
                    :class="
                      validateStateClass(
                        veeFields,
                        veeErrors,
                        `Porcentagem de incremento de ${cobertura.name}`,
                      )
                    "
                  ></vs-input>
                </td>
                <td>
                  <vs-input
                    class="w-full"
                    v-model="
                      formAgravoResposta.coberturas[index].coverage_limit
                    "
                    type="number"
                    step="0.01"
                    color="success"
                    icon-pack="feather"
                    icon="icon-percent"
                    :disabled="handleDisableAplicarAgravo(index)"
                    :id="`Limite de cobertura de ${cobertura.name}`"
                    :name="`Limite de cobertura de ${cobertura.name}`"
                    v-validate="{ required: true, min_value: 0, max_value: 100 }"
                    :state="
                      validateState(
                        veeFields,
                        veeErrors,
                        `Limite de cobertura de ${cobertura.name}`,
                      )
                    "
                    :class="
                      validateStateClass(
                        veeFields,
                        veeErrors,
                        `Limite de cobertura de ${cobertura.name}`,
                      )
                    "
                  ></vs-input>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <ErrorsAlert :errors="errors" />

      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button
            color="warning"
            type="border"
            class="mr-3 mb-2"
            @click.stop.prevent="closeModal"
            >Cancelar</vs-button
          >
          <BotaoSubmit
            variant="success"
            :edit="resposta.idRespostaAgravo == null ? false : true"
            :aguarde="aguardeCadastro"
          ></BotaoSubmit>
        </div>
      </div></form
  ></Modal>
</template>
<script>
import BotaoSubmit from '../../../../components/BotaoSubmit.vue';
import ErrorsAlert from '../../../../components/ErrorsAlert.vue';
import Modal from '../../../../components/Modal.vue';

import services from '../../../../services';
import utilsList from '../../../../utils/list';
import notify from '../../../../utils/notify';

export default {
  name: 'popup-agravo-resposta',
  components: {
    BotaoSubmit,
    ErrorsAlert,
    Modal
  },
  data() {
    return {
      popupActivo: false,
      aguardeCadastro: false,
      validateState: utilsList.validateState,
      validateStateClass: utilsList.validateStateClass,
      formAgravoResposta: {
        idRespostaAgravo: null,
        idAgravo: null,
        status: false,
        resposta: null,
        porcentagem: 0,
        negarProposta: false,
        coberturas: [],
      },
      resposta: {},
      listCoberturas: [],
      formCoberturaMontado: false,
    };
  },
  watch: {},
  computed: {
    errors() {
      return this.$validator.errors.all();
    },
    mostrarTabelaCoberturas() {
      return (
        !this.formAgravoResposta.negarProposta && this.formCoberturaMontado
      );
    },
  },
  methods: {
    open(resposta) {
      if (resposta) {
        this.resposta = resposta;
        this.preencheForm();
        this.montarFormCobertura();
      }

      this.popupActivo = true;
    },
    preencheForm() {
      this.formAgravoResposta.idRespostaAgravo = this.resposta.idRespostaAgravo;
      this.formAgravoResposta.idAgravo = this.resposta.idAgravo;
      this.formAgravoResposta.status = this.resposta.deletedAt ? false : true;
      this.formAgravoResposta.resposta = this.resposta.resposta;
      this.formAgravoResposta.porcentagem = 0;
      this.formAgravoResposta.negarProposta = this.resposta.negarProposta
        ? this.resposta.negarProposta
        : false;
    },
    resetForm() {
      this.formCoberturaMontado = false;
      this.formAgravoResposta = {
        idRespostaAgravo: null,
        idAgravo: null,
        status: false,
        resposta: null,
        porcentagem: 0,
        negarProposta: false,
        coberturas: [],
      };
    },
    async buscarCoberturas() {
      try {
        const controllerName = 'vida';
        const action = 'coberturas';

        this.$vs.loading();

        const { data } = await services.getAll(controllerName, null, action);

        this.listCoberturas = data;
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    async montarFormCobertura() {
      if (!this.listCoberturas.length) {
        await this.buscarCoberturas();
      }

      this.formAgravoResposta.coberturas = [];

      for (const cobertura of this.listCoberturas) {
        const { id: idCobertura, name } = cobertura;

        const { idRespostaAgravo, life_coverage_has_agravos_respostas } =
          this.resposta;

        const cobertura_reposta = life_coverage_has_agravos_respostas
          ? life_coverage_has_agravos_respostas.find(
              (l) =>
                l.agravos_respostas_id === idRespostaAgravo &&
                l.life_coverage_id === idCobertura,
            )
          : undefined;

        const id = cobertura_reposta ? cobertura_reposta.id : null;

        const increase_apply = cobertura_reposta
          ? cobertura_reposta.increase_apply
          : true;

        const offer_coverage = cobertura_reposta
          ? cobertura_reposta.offer_coverage
          : true;

        const increase_percentage = cobertura_reposta
          ? cobertura_reposta.increase_percentage
          : 0;

        const coverage_limit = cobertura_reposta
          ? cobertura_reposta.coverage_limit
          : 100;

        this.formAgravoResposta.coberturas.push({
          id,
          life_coverage_id: idCobertura,
          agravos_respostas_id: idRespostaAgravo,
          name,
          increase_apply,
          offer_coverage,
          increase_percentage,
          coverage_limit,
        });
      }

      this.formCoberturaMontado = true;
    },
    handleDisableOfertarCobertura(index) {
      const ofertar = this.formAgravoResposta.coberturas[index].offer_coverage;

      if (!ofertar) {
        this.formAgravoResposta.coberturas[index].increase_apply = false;
        this.formAgravoResposta.coberturas[index].increase_percentage = 0;
        this.formAgravoResposta.coberturas[index].coverage_limit = 100;
      }

      return !ofertar;
    },
    handleDisableAplicarAgravo(index) {
      const aplicar = this.formAgravoResposta.coberturas[index].increase_apply;

      if (!aplicar) {
        this.formAgravoResposta.coberturas[index].increase_percentage = 0;
        this.formAgravoResposta.coberturas[index].coverage_limit = 100;
      }

      return !aplicar;
    },
    async onSubmit() {
      const validated = await this.$validator.validateAll();
      if (!validated) {
        return;
      }

      try {
        this.$vs.loading();
        await services.post(
          'agravos',
          'agravos-resposta-vida',
          this.formAgravoResposta,
        );

        notify.notifySuccess(this.$vs, 'Operação realizada com sucesso!');

        this.closeModal();
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    closeModal() {
      this.resetForm();
      this.popupActivo = false;
      this.$emit('close', true);
    },
  },
};
</script>
<style>
.styled-table {
  width: 100%;
  border-collapse: collapse;
}
.styled-table th,
.styled-table td {
  border: 1.4px solid #d3d3d3;
  padding: 6px;
  text-align: center;
}
.styled-table th {
  background-color: #f2f2f2;
}
.con-vs-checkbox,
.con-vs-radio {
  justify-content: center !important;
}

.styled-table tr td input:nth-last-child(-n + 1) {
  border: none;
}
</style>
